import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { notifyParent } from 'Helpers/notifyParent'

import { getResponse, pageState } from '../recoil/state/page'
import { modalDelete } from '../recoil/state/modals'

import {
  MessageBox,
  MESSAGE_BOX_VARIANT_WARNING,
  Button,
  BUTTON_VARIANT_NEGATIVE,
  Flex,
  FlexItem
} from 'mailup-web-components'
import Details from './Details'
import { WARNING_ACTION_EDIT, WARNING_ACTION_PREVIEW } from '../const'

const MessageBoxWarning = () => {
  const intl = useIntl()
  const history = useHistory()
  const setModalState = useSetRecoilState(modalDelete)

  const { IdMessage: idMessage, Details: details } = useRecoilValue(getResponse)
  const [{ subject, warningAction }, setPageState] = useRecoilState(pageState)

  const handleBtnPreviewClick = () => {
    setPageState(prev => ({
      ...prev,
      isDirty: false,
      warningAction: WARNING_ACTION_PREVIEW
    }))
  }

  const handleBtnEditClick = () => {
    setPageState(prev => ({
      ...prev,
      isDirty: false,
      warningAction: WARNING_ACTION_EDIT
    }))
  }

  const handleBtnDiscardClick = () => {
    setModalState(prev => ({
      ...prev,
      show: true,
      idMessage
    }))
  }

  // permette di resettare a false lo stato di dirty in pagina per poter uscire dalla rotta
  useEffect(() => {
    if (warningAction) {
      if (warningAction === WARNING_ACTION_PREVIEW) {
        const route = `/messages/email/${idMessage}/overview?source=EmailMessages&op=mod`
        history.push(route)
      } else {
        notifyParent('redirectMainFrame', [
          `form_upd_newsletter.aspx?source=listemail&idNL=${idMessage}`
        ])
      }
    }
  }, [warningAction])

  return (
    <MessageBox
      variant={MESSAGE_BOX_VARIANT_WARNING}
      data-mu-test='message-box-warning'
    >
      {intl.formatMessage(
        {
          id: 'Load.EmailMessageImport.warningMessageNew'
        },
        {
          SUBJECT: subject
        }
      )}

      <>
        {details.map((e, index) => (
          <Details
            key={index}
            index={index}
            detailCode={e.Code}
            detailArray={e.Items}
          />
        ))}
      </>

      <Flex margin='16px 0 0 0'>
        <FlexItem>
          <Button kind={BUTTON_VARIANT_NEGATIVE} onClick={handleBtnEditClick}>
            {intl.formatMessage({
              id: 'Load.EmailMessageImport.WarningBtnEdit'
            })}
          </Button>
        </FlexItem>
        <FlexItem margin='0 16px'>
          <Button
            kind={BUTTON_VARIANT_NEGATIVE}
            onClick={handleBtnPreviewClick}
          >
            {intl.formatMessage({
              id: 'Load.EmailMessageImport.WarningBtnOveview'
            })}
          </Button>
        </FlexItem>
        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_NEGATIVE}
            onClick={handleBtnDiscardClick}
          >
            {intl.formatMessage({
              id: 'Load.EmailMessageImport.WarningBtnDelete'
            })}
          </Button>
        </FlexItem>
      </Flex>
    </MessageBox>
  )
}

export default MessageBoxWarning
